import { Component, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';

@Component({
  selector: 'skc-bread-crumb-base',
  templateUrl: './bread-crumb-base.component.html',
  styleUrls: ['./bread-crumb-base.component.less']
})
export class BreadCrumbBaseComponent extends SkeletonSizeBase implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
